<div class="row">
  <div class="col-md-12">
    <table class="width-100per">
      <thead>
        <tr class="border-bottom-0px">
          <td>
            <div class="printheader2-space">&nbsp;</div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr class="border-bottom-0px">
          <td>
            <div class="content">
              <div class="row">
                <div class="col-md-12">
                  <router-outlet></router-outlet>
                  <!--<router-outlet name="eggsource"></router-outlet>
                  <router-outlet name="folliculargrowth"></router-outlet>
                  <router-outlet name="pickupdetails"></router-outlet>
                  <router-outlet name="oocytequality"></router-outlet>
                  <router-outlet name="spermsourcedetails"></router-outlet>
                  <router-outlet name="semendataanalysis"></router-outlet>
                  <router-outlet name="inseminationlog"></router-outlet>
                  <router-outlet name="embryotransfer"></router-outlet>-->
                </div>
              </div>

            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="border-bottom-0px">
          <td>
            <div class="printfooter-space">&nbsp;</div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>



<!--<div class="printheader">
  <router-outlet name="printheaderview"></router-outlet>
</div>
<div class="printfooter">
  <router-outlet name="printfooterview"></router-outlet>
</div>-->
 
